import React, { useEffect } from 'react';

import ChartGauge from '../../components/Dashboard/Gauge';
import ChartDonut from '../../components/Dashboard/Donut';
import ChartBar from '../../components/Dashboard/Bar';
import { EChartsOption } from 'echarts';

const TabDashboard: React.FC = () => {

    const stepsGauge = [
        {
            percent: 10,
            status: "danger"
        },
        {
            percent: 20,
            status: "warning"
        },
        {
            percent: 70,
            status: "success"
        }
    ]

    const dataDonuts = [
        { value: 3200, name: "Abertos" },
        { value: 3800, name: "Fechados" },
        { value: 2234, name: "Pendentes" },
        { value: 1890, name: "Cancelados" }
    ]

    const dataBars: EChartsOption = {
        xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                data: [120, 200, 150, 80, 70, 110, 130],
                type: 'bar'
            }
        ]
    };

    return <div className='scrollable-v' style={{ height: '100%' }}>
        <div className='row start' >
            <ChartGauge title='Teste small' size='small' value={55} steps={stepsGauge as any} />
            <ChartGauge
                title='Teste medium'
                value={87}
                steps={stepsGauge as any}
            />
            <ChartGauge title='Teste big' size="big" value={93} steps={stepsGauge as any} />
        </div>

        <div className='row start' >
            <ChartDonut size='small' showTotal data={dataDonuts} renderValue={value => { return value + ".00" }} />
            <ChartDonut data={dataDonuts} showTotal />
            <ChartDonut size="big" showTotal data={dataDonuts} renderValue={value => { return value }} />
        </div>

        <div className='row start' style={{ height: "400px" }} >
            <ChartBar options={dataBars} />
        </div>

    </div>
}

export default TabDashboard;